/**
 * Theme Ajax Cart API — same origin as the storefront (embedded search / PLP).
 * @see https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function updateCartCountBadges(count) {
    const countSelectors = [
        '[data-cart-count]',
        '[data-item-count]',
        '#cart-count',
        '.cart-count',
        '.cart__count',
        '.cart-icon-bubble__count',
        '[data-cart-item-count]',
    ];
    countSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
            el.textContent = String(count);
            el.setAttribute('data-cart-count', String(count));
            el.setAttribute('data-item-count', String(count));
        });
    });
}
function getCartDrawer() {
    return document.querySelector('cart-drawer');
}
/** Section IDs for bundled rendering (e.g. Dawn’s cart-drawer + cart-icon-bubble). */
function getBundledSectionIds(drawer) {
    if (drawer === null || drawer === void 0 ? void 0 : drawer.getSectionsToRender) {
        try {
            const list = drawer.getSectionsToRender();
            const ids = list.map(s => s.id).filter(Boolean);
            if (ids.length)
                return ids.join(',');
        }
        catch (_a) {
            /* theme may throw if drawer not ready */
        }
    }
    return undefined;
}
function openCartDrawerFallback(drawer) {
    if (drawer === null || drawer === void 0 ? void 0 : drawer.open) {
        try {
            drawer.open();
            return;
        }
        catch (_a) {
            /* fall through */
        }
    }
    document.dispatchEvent(new CustomEvent('cart-drawer-open'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('mini-cart:open'));
}
export function addVariantToShopifyThemeCart(variantId) {
    return __awaiter(this, void 0, void 0, function* () {
        const drawer = getCartDrawer();
        const sectionsParam = getBundledSectionIds(drawer);
        const payload = {
            items: [{ id: variantId, quantity: 1 }],
        };
        if (sectionsParam) {
            payload.sections = sectionsParam;
            payload.sections_url = window.location.pathname;
        }
        const addResponse = yield fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });
        if (!addResponse.ok)
            throw new Error('Failed to add to cart');
        const addData = (yield addResponse.json());
        if (typeof addData.item_count === 'number') {
            updateCartCountBadges(addData.item_count);
        }
        if (drawer &&
            typeof drawer.renderContents === 'function' &&
            addData.sections &&
            sectionsParam &&
            Object.keys(addData.sections).length > 0) {
            try {
                drawer.renderContents(addData);
                // `drawer.renderContents` dispatches `cart:updated` itself (see
                // assets/cart-drawer.js), so we don't need to fire it again here.
                return;
            }
            catch (e) {
                console.warn('[shopifyThemeCart] renderContents failed, using fallback open', e);
            }
        }
        const cartResponse = yield fetch('/cart.js');
        const cart = yield cartResponse.json();
        const count = cart.item_count;
        updateCartCountBadges(count);
        // Fallback path doesn't go through `drawer.renderContents`, so emit the
        // cart-drawer-DOM-updated notification ourselves. `cart-drawer:refresh`
        // below also triggers a re-render via the theme's listener, which will
        // dispatch the same event — that's idempotent for our subscribers
        // (re-running with the same DOM state is a no-op).
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
        openCartDrawerFallback(drawer);
    });
}
